import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";
import Inbox from "../page";

const routes: AppRouteType[] = [
  {
    path: slugs.inbox,
    component: Inbox,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
